import React from "react";

type AppErrorBoundaryProps = {
  children: React.ReactNode;
};

type AppErrorBoundaryState = {
  error: Error | null;
};

export class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = {
    error: null,
  };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("App startup failed:", error, errorInfo);
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <div className="min-h-screen bg-background px-4 py-10">
        <div className="mx-auto flex max-w-lg flex-col gap-4 rounded-2xl border border-border bg-card p-6 shadow-sm">
          <div className="space-y-2">
            <h1 className="text-2xl font-semibold text-foreground">Chronos hit a startup error</h1>
            <p className="text-sm leading-6 text-muted-foreground">
              Try refreshing the page or disabling browser blockers for this site. If storage or auth is being blocked,
              Chronos may not be able to restore your session.
            </p>
            <p className="rounded-md bg-muted px-3 py-2 font-mono text-xs text-muted-foreground">
              {this.state.error.message || "Unknown startup error"}
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
            >
              Reload
            </button>
            <button
              onClick={() => {
                window.location.href = "/auth";
              }}
              className="inline-flex items-center justify-center rounded-md border border-border px-4 py-2 text-sm font-medium text-foreground"
            >
              Open Sign In
            </button>
          </div>
        </div>
      </div>
    );
  }
}
